var _ = require('underscore');
var Backbone = require('backbone');
var Result = require('./Result');


var ResultStore = Backbone.Collection.extend({
    model: Result,

	comparator: function(result) {
        return result.attributes.sort[0];
    },

    getVisible: function() {
        return _(this.filter(function(result) {
            return result.get("visible");
        }));
    },

});


module.exports = ResultStore;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/ResultStore.js